module.exports = __webpack_public_path__ + "static/simona3-de0231c306843e1c42f6483bbe22924b.jpg";